/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgShopeeFood = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <rect width={40} height={40} fill="currentColor" rx={20} />
    <path
      fill="#F7FFFE"
      d="M29.636 13.966a.41.41 0 0 0-.08-.242s-2.163-3.246-2.276-3.438c-.114-.19-.154-.286-.342-.286h-13.89c-.188 0-.228.095-.342.286-.101.17-1.782 2.642-2.163 3.213 0 0-.242.311-.242.467 0 .156 0 .022.001.032l.638 14.026.01.176c.097.975.81 1.762 1.78 1.798L26.988 30h.072c.987-.027 1.786-.825 1.87-1.813l.006-.119.699-14.08v-.022Zm-5.532-.012h-8.272v-1.907c0-.226.183-.409.409-.409h7.455c.225 0 .408.183.408.409v1.907Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24.56 24.755V30h-2.166v-5.245c0-1.016-.507-1.38-.507-1.38-.74-.638-1.226-1.72-1.226-2.947 0-1.962 1.244-3.768 2.779-3.768 1.534 0 2.778 1.806 2.778 3.768 0 1.227-.485 2.308-1.225 2.947 0 0-.433.364-.433 1.38Zm-6.919.701V30h-2.166v-4.544c0-1.18-.071-1.251-.627-1.805l-.046-.046c-.597-.598-.597-1.078-.597-1.078v-5.194c0-.233.189-.422.422-.422h.7v4.338a.375.375 0 0 0 .75 0V16.91h.963v4.338a.375.375 0 0 0 .75 0V16.91h.703c.23 0 .418.187.418.418v5.198s0 .48-.598 1.078l-.046.046c-.555.555-.626.626-.626 1.805Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgShopeeFood)
export default Memo
